import { useEffect } from "react"
import { useNavigate } from "react-router/dist"

export const ResetStorage = () => {
  const navigate = useNavigate()

  // Reset local storage and session storage
  const handleResetStorage = () => {
    localStorage.clear()
    sessionStorage.clear()
    // Redirect to the login page or any other desired location
    navigate('/login')
  }

  useEffect(() => {
    handleResetStorage()
  }, [])

  return (
    // You can customize the UI for the reset storage page
    <div>
      <p>This page is for resetting storage. Are you sure you want to proceed?</p>
      <button onClick={handleResetStorage}>Reset Storage</button>
    </div>
  )
}